export interface CalculatorInfo {
  id: string;
  title: string;
  description: string;
  icon: string;
  route: string;
  color: string;
  badge?: string;
}

export const calculators: CalculatorInfo[] = [
  {
    id: "sip",
    title: "SIP Calculator",
    description: "Calculate your mutual fund SIP returns. See how much wealth you can create with monthly investments over time.",
    icon: "ri-line-chart-line",
    route: "/calculator/sip",
    color: "bg-emerald-50 text-emerald-600",
    badge: "Most Popular",
  },
  {
    id: "health",
    title: "Health Insurance Calculator",
    description: "Estimate your health insurance premium based on age, coverage amount, family size, and medical history.",
    icon: "ri-hospital-line",
    route: "/calculator/health",
    color: "bg-red-50 text-red-600",
  },
  {
    id: "term",
    title: "Term Insurance Calculator",
    description: "Calculate the ideal term insurance coverage and premium based on your income, liabilities, and dependents.",
    icon: "ri-shield-check-line",
    route: "/calculator/term",
    color: "bg-blue-50 text-blue-600",
  },
  {
    id: "retirement",
    title: "Retirement Calculator",
    description: "Find out how much corpus you need for retirement and how much to save monthly to reach your goal.",
    icon: "ri-timer-line",
    route: "/calculator/retirement",
    color: "bg-violet-50 text-violet-600",
  },
  {
    id: "child-education",
    title: "Child Education Calculator",
    description: "Plan for your child's higher education by calculating the future cost and monthly savings required.",
    icon: "ri-graduation-cap-line",
    route: "/calculator/child-education",
    color: "bg-amber-50 text-amber-600",
  },
  {
    id: "hlv",
    title: "Human Life Value (HLV) Calculator",
    description: "Determine the economic value of your life to decide the right amount of life insurance coverage.",
    icon: "ri-user-heart-line",
    route: "/calculator/hlv",
    color: "bg-rose-50 text-rose-600",
  },
  {
    id: "need-analysis",
    title: "Insurance Need Analysis",
    description: "Comprehensive analysis of your insurance needs across health, life, and disability coverage.",
    icon: "ri-file-list-3-line",
    route: "/calculator/need-analysis",
    color: "bg-cyan-50 text-cyan-600",
  },
];